/* global google */
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";

import InputForm from "../../partials/inputForm";
import { styles } from "./styles";

import "./index.css";
/* global google */

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
  }

  componentDidMount() {
    this.autocompleteFunc();
    const _this = this;
    const { auto } = _this.props;
    if (navigator.geolocation && auto) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          // success cb
          let location = position.coords;
          var latLng = new google.maps.LatLng(
            location.latitude,
            location.longitude
          );

          var geocoder = new google.maps.Geocoder();
          if (geocoder) {
            geocoder.geocode({ latLng: latLng }, function (results, status) {
              if (
                status === google.maps.GeocoderStatus.OK &&
                results &&
                results[0]
              ) {
                results = results[0];
                let data = {};
                data.address = results.formatted_address;
                let address_components = results.address_components;
                address_components.forEach((e) => {
                  if (
                    e.types.find((e1) => e1 === "administrative_area_level_2")
                  ) {
                    return (data.district = e.short_name);
                  } else if (
                    e.types.find((e1) => e1 === "administrative_area_level_1")
                  ) {
                    return (data.city = e.short_name);
                  } else if (e.types.find((e1) => e1 === "country")) {
                    return (data.country = e.short_name);
                  } else if (e.types.find((e1) => e1 === "locality")) {
                    return (data.state = e.short_name);
                  }
                });
                data.lat = location.latitude;
                data.lng = location.longitude;
                _this.props.handleChange(data);
              } else {
                console.log("Geocoding failed: " + status);
              }
            }); //geocoder.geocode()
          }
        },
        function (err) {
          // fail cb
          console.log(err);
        }
      );
    }
  }
  // componentDidUpdate() {
  //     this.autocompleteFunc()
  // }
  autocompleteFunc = () => {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.autocompleteInput.current,
      { types: ["geocode"] }
    );
    this.autocomplete.addListener("place_changed", this.handlePlaceChanged); // call when click to suggess address of Google map
  };
  handleOnchange = (e) => {
    this.props.handleChange({
      address: e.target.value,
      lat: "",
      lng: "",
      district: "",
      city: "",
      country: "",
      state: "",
    });
  };
  handlePlaceChanged = async () => {
    const place = await this.autocomplete.getPlace();
    this.showPlaceDetails(place);
  };

  showPlaceDetails = (place) => {
    let data = {};
    data.address = place.formatted_address;
    data.addressData = place.formatted_address;

    let address_components = place.address_components;
    if (address_components) {
      address_components.forEach((e) => {
        if (e.types.find((e1) => e1 === "administrative_area_level_2")) {
          data.district = e.short_name;
        } else if (e.types.find((e1) => e1 === "administrative_area_level_1")) {
          data.city = e.short_name;
        } else if (e.types.find((e1) => e1 === "country")) {
          data.country = e.short_name;
        } else if (e.types.find((e1) => e1 === "locality")) {
          data.state = e.short_name;
        }
      });
      if (place.geometry && place.geometry.location) {
        var lat = place.geometry.location.lat(),
          lng = place.geometry.location.lng();
        data.lat = lat;
        data.lng = lng;
      }
      this.props.handleChange(data);
    }
  };

  render() {
    const {
      name,
      value,
      required,
      label,
      InputProps,
      InputLabelProps,
      disabled = false,
      ...props
    } = this.props;
    return (
      <InputForm
        {...props}
        required={required}
        disabled={disabled}
        label={label}
        name={name}
        value={value}
        InputProps={{
          ...InputProps,
          inputRef: this.autocompleteInput,
          onChange: this.handleOnchange,
          type: "text",
          id: "autocomplete",
        }}
        fullWidth
        onChange={this.handleOnchange}
      />
    );
  }
}

const mapState = (state) => ({});

const mapDidatatch = (didatatch) => ({});

export default connect(
  mapState,
  mapDidatatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Address)));
